define("shared/components/shared/publish/switcher/item/publish-method/index", ["exports", "@ember/component", "@ember/component/template-only", "@ember/template-factory"], function (_exports, _component, _templateOnly, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@ember/component/template-only",0,"@ember/component"eaimeta@70e063a35619d71f
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    <div class="o--dropBody">
    <ul class="o--dropBody__list">
      <li class="o--dropBody__item">
        <Shared::Ui::Button
          @class="o--dropBody__link qa_publishMethod_toggle"
          @onClick={{@setPublishMethod}}
          @text={{@text}}
          @variant="unstyled"
          data-test-id="publish-method"
        />
      </li>
    </ul>
  </div>
  */
  {
    "id": "lLM/N5xZ",
    "block": "[[[10,0],[14,0,\"o--dropBody\"],[12],[1,\"\\n  \"],[10,\"ul\"],[14,0,\"o--dropBody__list\"],[12],[1,\"\\n    \"],[10,\"li\"],[14,0,\"o--dropBody__item\"],[12],[1,\"\\n      \"],[8,[39,0],[[24,\"data-test-id\",\"publish-method\"]],[[\"@class\",\"@onClick\",\"@text\",\"@variant\"],[\"o--dropBody__link qa_publishMethod_toggle\",[30,1],[30,2],\"unstyled\"]],null],[1,\"\\n    \"],[13],[1,\"\\n  \"],[13],[1,\"\\n\"],[13]],[\"@setPublishMethod\",\"@text\"],false,[\"shared/ui/button\"]]",
    "moduleName": "shared/components/shared/publish/switcher/item/publish-method/index.hbs",
    "isStrictMode": false
  });
  var _default = _exports.default = (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, (0, _templateOnly.default)());
});